/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditNewScorecardAttributeSelectRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit.new-scorecard.attribute-select',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditNewScorecardAttributeSelectRoute);
